var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorderDesktopWavyBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 64,
    viewBox: "0 0 1440 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312 15.7375C503.25 15.7375 577.125 94.0047 772.875 51.199C968.625 8.39323 1135.12 30.8453 1250.62 30.8453C1366.12 30.8453 1440 0 1440 0H0V51.1989C0 51.1989 120.75 15.7376 312 15.7375Z",
    fill: "#F5FFF7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderDesktopWavyBottom);
export default __webpack_public_path__ + "static/media/border-desktop-wavy-bottom.6cdff58a741fade357103f4aacae93ea.svg";
export { ForwardRef as ReactComponent };